/**
 * Facet key -> Lokalise key.
 *
 * Most facets follow the `listing:filter-<kebab-key>` convention, so only the
 * exceptions are listed here. Anything with no key at all falls back to
 * `humanizeFacetKey`, which keeps new API facets rendering (in English) until
 * a translation is added.
 */
const FACET_LABEL_KEYS: Record<string, string> = {
  /* The convention lands on `listing:filter-country`, which reads "Location" — the facet buckets
   * countries, so it is named after what it actually filters on. */
  country: "common:common-country",
  designer: "common:common-designer-item",
  gender: "common:common-gender",
  showroom_model: "listing:listing-showroom",
  availability: "listing:listing-availability",
  allow_bid: "listing:listing-bidding",
  discount_percentage: "listing:filter-sale",
  number_of_items: "listing:filter-items",
  width: "listing:search_filters_width",
  height: "listing:search_filters_height",
  depth: "listing:search_filters_depth",
};

export const getFacetLabelKey = (facetKey: string) =>
  FACET_LABEL_KEYS[facetKey] ?? `listing:filter-${facetKey.replace(/_/g, "-")}`;

/**
 * Facet key -> Lokalise key for its single `true` row.
 *
 * An opt-in boolean facet is one checkbox, and the service sends it with `label: null` — it has no
 * vocabulary for "available", only the raw `true`. So the row is named here instead, and the section
 * heading above it (`FACET_LABEL_KEYS`) names the axis: "Availability" over "Available".
 */
const BOOLEAN_VALUE_LABEL_KEYS: Record<string, string> = {
  availability: "listing:listing-available",
  allow_bid: "listing:listing-bidding-possible",
  /* Same key as the section above it — "Showroom model" names both the axis and the one thing you
   * can tick, so there is no second string to write. */
  showroom_model: "listing:listing-showroom",
};

export const getFacetValueLabelKey = (facetKey: string): string | undefined =>
  BOOLEAN_VALUE_LABEL_KEYS[facetKey];

/**
 * Last-resort label for a facet with no translation: `art_orientation` ->
 * `Art orientation`.
 */
export const humanizeFacetKey = (key: string) =>
  key.replace(/_/g, " ").replace(/^\w/, char => char.toUpperCase());
